
/**
 * Custom component for Oceano steak menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoSteakSection> adds a steak layout for Oceano menu sections.
 *
 *  2025-04-08 (1.0.1) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <OceanoSteakSection>.
 *    - Remove "visual_" prefix from class names in <OceanoSteakSection>.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoSteakSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
